module.exports = __webpack_public_path__ + "img/photo-4.f5594b14.jpg";